import { AccountTypeId } from '../../model/account/accountTypeId';
import { Role } from '../../model/account/role';

const DashboardRoutes = [
  {
    path: '/dashboard/patients',
    sidebarName: 'sidebar.patients',
    icon: 'PatientsIcon',
    permissions: [AccountTypeId[AccountTypeId.HealthcareProfessional]],
  },
  {
    path: '/dashboard/admin',
    sidebarName: 'sidebar.admin',
    icon: 'AdminMan',
    permissions: [Role[Role.SuperAdmin], Role[Role.Admin]],
  },
  {
    path: '/dashboard/support',
    sidebarName: 'sidebar.support',
    icon: 'SupportIcon',
    permissions: [
      AccountTypeId[AccountTypeId.HealthcareProfessional],
      AccountTypeId[AccountTypeId.Patient],
      AccountTypeId[AccountTypeId.Account],
      Role[Role.Admin],
      Role[Role.User],
    ],
  },
  {
    path: '/dashboard/monitoring',
    sidebarName: 'sidebar.monitoring',
    icon: 'MonitorIconMui',
    permissions: [Role[Role.SuperAdmin]],
  },
];

export default DashboardRoutes;
